import axios from 'axios'

axios.defaults.withCredentials = true

export default {
  getAllServicesType: function () {
    return axios.get(`${window.apiURL}api/user/services-on-demand-type`)
  },
  getAllServices: function () {
    return axios.get(`${window.apiURL}api/user/services-on-demand`)
  },
  createRequest: function (idServiceType) {
    return axios.post(`${window.apiURL}api/user/services-on-demand/`, { params: {service_type: idServiceType} })
  },
  getService: function (id) {
    return axios.get(`${window.apiURL}api/user/services-on-demand/${id}`)
  },
  getServiceByDistro: function (idDistribution, key) {
    return axios.get(`${window.apiURL}api/user/services-on-demand/by-distribution/${idDistribution}/${key}`)
  },
  getServiceByArtist: function (idArtist) {
    return axios.get(`${window.apiURL}api/user/services-on-demand/by-artist/${idArtist}`)
  },
  getServicesBy: function (key) {
    return axios.get(`${window.apiURL}api/user/services-on-demand/available-by/${key}`)
  },
  deleteServiceFromDistro: function (id, idDistribution) {
    return axios.put(`${window.apiURL}api/user/services-on-demand/${id}/remove`, { distribution: idDistribution })
  },
  setServicetoDistro: function (id, idDistribution) {
    return axios.put(`${window.apiURL}api/user/services-on-demand/${id}/add`, { distribution: idDistribution })
  }
}



// WEBPACK FOOTER //
// ./src/services/services-on-demand.js